import cozinha1 from "./cozinha1.jpeg";
import cozinha2 from "./cozinha2.jpeg";
import cozinha3 from "./cozinha3.jpeg";
import cozinha4 from "./cozinha4.jpeg";
import cozinha5 from "./cozinha5.jpeg";
import quarto1 from "./quarto1.jpeg";
import quarto2 from "./quarto2.jpeg";
import quarto3 from "./quarto3.jpeg";
import quarto4 from "./quarto4.jpeg";
import quarto5 from "./quarto5.jpeg";
import banheiro1 from "./banheiro1.jpeg";
import banheiro2 from "./banheiro2.jpeg";
import banheiro3 from "./banheiro3.jpeg";

const imagensAp3 = [
  cozinha3,
  cozinha1,
  cozinha2,
  cozinha4,
  cozinha5,
  quarto1,
  quarto2,
  quarto3,
  quarto4,
  quarto5,
  banheiro1,
  banheiro2,
  banheiro3,
];

export default imagensAp3;
